import * as React from "react";
import { SVGProps, memo } from "react";

const SvgCheckInQr = (props: SVGProps<SVGSVGElement>) => (
  <svg width={128} height={136} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#CheckInQr_svg__a)">
      <path
        d="m62.363 66.836 2.76.5s9.699 4.09 14.53 8.824v5.338h-17.29V66.836Z"
        fill="#fff"
        stroke="#272C33"
        strokeWidth={1.726}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <mask
        id="CheckInQr_svg__b"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={38}
        y={53}
        width={19}
        height={31}
      >
        <path d="M56.289 53.117H38.624v30.584H56.29V53.117Z" fill="#fff" />
      </mask>

      <g mask="url(#CheckInQr_svg__b)">
        <path
          d="M51.014 56.247s.587 4.722-.253 9.013a7.58 7.58 0 0 1-.81 2.203c-.42.76-1.83 2.1-2.635 2.537-2.778 1.496-5.867 2.525-5.867 2.525-1.19.53-2.238 2.698-1.663 4.728.794 2.802 2.68 3.33 4.82 3.94.564.162 1.128.334 2.014.484 4.757.81 9.813 1.668 12.505.35 3.934-1.926 1.052-8.852.212-15.725-.638-5.229 1.697-10.797-1.323-11.999-2.34-.932-6.994 1.944-6.994 1.944h-.006Z"
          fill="#fff"
          stroke="#272C33"
          strokeWidth={1.99}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <mask
        id="CheckInQr_svg__c"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={56}
        y={53}
        width={18}
        height={31}
      >
        <path d="M73.947 53.117H56.283v30.584h17.664V53.117Z" fill="#fff" />
      </mask>

      <g mask="url(#CheckInQr_svg__c)">
        <path
          d="M61.557 56.247s-.587 4.722.253 9.013c.104.518.317 1.312.811 2.203.42.76 1.83 2.1 2.635 2.537 2.778 1.496 5.867 2.525 5.867 2.525 1.19.53 2.237 2.698 1.662 4.728-.794 2.802-2.68 3.33-4.82 3.94-.564.162-1.127.334-2.013.484-4.757.81-9.813 1.668-12.505.35-3.934-1.926-1.053-8.852-.213-15.725.639-5.229-1.697-10.797 1.323-11.999 2.341-.932 6.994 1.944 6.994 1.944h.006Z"
          fill="#fff"
          stroke="#272C33"
          strokeWidth={1.99}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <path
        d="M71.174 72.521s-3.088-1.024-5.867-2.525c-.81-.437-2.22-1.777-2.634-2.537a7.7 7.7 0 0 1-.81-2.203c-.84-4.296-.254-9.013-.254-9.013s-1.254-.77-2.79-1.386a2.17 2.17 0 0 0-.805-.558c-.489-.196-1.076-.219-1.703-.138-.627-.075-1.213-.052-1.702.138a2.17 2.17 0 0 0-.806.558 20.65 20.65 0 0 0-2.79 1.386s.587 4.722-.252 9.013a7.58 7.58 0 0 1-.811 2.203c-.42.76-1.83 2.1-2.635 2.537-2.778 1.496-5.867 2.525-5.867 2.525-1.19.53-2.237 2.698-1.662 4.728.794 2.801 2.68 3.33 4.82 3.94.564.161 1.127.334 2.013.484 3.406.58 6.96 1.179 9.692.989 2.733.184 6.287-.414 9.693-.99.885-.15 1.449-.322 2.013-.483 2.145-.61 4.026-1.139 4.82-3.94.575-2.03-.472-4.204-1.663-4.728Z"
        fill="#fff"
      />

      <path
        d="M71.174 72.521s-3.088-1.024-5.867-2.525c-.81-.437-2.22-1.777-2.634-2.537a7.7 7.7 0 0 1-.81-2.203c-.84-4.296-.254-9.013-.254-9.013s-1.254-.77-2.79-1.386a2.17 2.17 0 0 0-.805-.558c-.489-.196-1.076-.219-1.703-.138-.627-.075-1.213-.052-1.702.138a2.17 2.17 0 0 0-.806.558 20.65 20.65 0 0 0-2.79 1.386s.587 4.722-.252 9.013a7.58 7.58 0 0 1-.811 2.203c-.42.76-1.83 2.1-2.635 2.537-2.778 1.496-5.867 2.525-5.867 2.525-1.19.53-2.237 2.698-1.662 4.728.794 2.801 2.68 3.33 4.82 3.94.564.161 1.127.334 2.013.484 3.406.58 6.96 1.179 9.692.989 2.733.184 6.287-.414 9.693-.99.885-.15 1.449-.322 2.013-.483 2.145-.61 4.026-1.139 4.82-3.94.575-2.03-.472-4.204-1.663-4.728Z"
        stroke="#272C33"
        strokeWidth={1.99}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M43.703 73.826c8.438 1.202 17.049 1.208 25.47-.103-.006.04-.012.08-.012.31a31.874 31.874 0 0 1 5.96 12.844c.31 1.473.517 2.957.724 4.447.357 2.554.713 5.113 1.064 7.667.294 2.094.581 4.193.823 6.293 1.317 11.676.937 23.491 2.29 35.196-.162.219-.07.57.183.667 0 .023-.011.046-.098.012-3.083 1.254-6.488 1.403-9.818 1.536-4.62.184-9.238.368-13.857.546-2.945.115-5.896.23-8.83-.017-4.946-.42-9.737-1.864-14.483-3.302a155.25 155.25 0 0 1 1.536-24.889c1.266-8.846 3.296-17.583 4.326-26.459.276-2.404.489-4.831 1.144-7.155.742-2.617 2.025-5.045 3.59-7.587l-.012-.006Z"
        fill="#CAECD1"
        stroke="#272C33"
        strokeWidth={1.99}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M36.461 120.724c-1.26-1.093.72-2.859.72-2.859l1.472-4.67c2.266-4.286-.293-4.861 2.738-11.378 2.968-6.367 6.344-14.598 6.994-18.584.19-1.145.219-2.33-.075-3.452-.655-2.519-1.42-3.715-4.348-4.716 0 0-1.933-.61-4.187-.173-1.415.27-2.618.978-2.618.978a32.802 32.802 0 0 0-9.933 13.103c-1.047 2.52-1.772 5.154-2.497 7.782-1.95 7.098-2.628 10.084-1.541 14.501.5 2.031 15.795 11.648 13.275 9.468Z"
        fill="#fff"
        stroke="#272C33"
        strokeWidth={1.99}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M43.53 71.185c-2.231 1.081-5.027 3.716-6.143 4.521-.247.178-8.363 53.982-14.984 125.802 8.795 1.829 19.753 2.49 28.616.995 0 0 3.664-73.488-3.48-134.487-1.409.396-2.628 1.07-3.514 1.639-.316.201-.477 1.513-.558 1.88-.54 2.48-.713 3.205-1.104 5.799-.38 2.537-1.099 5.021-1.318 7.575-.023.27-.04.552.052.805.11.305.357.541.599.76a85.786 85.786 0 0 0 5.337 4.452c-1.052 1.996-2.105 3.992-3.157 5.982-.11.201-.22.42-.208.65.012.224.133.425.254.615 2.312 3.716 4.63 7.432 6.942 11.153"
        fill="#fff"
      />

      <path
        d="M33.585 103.488c-2.933 20.926-6.666 49.036-11.182 98.014 8.795 1.829 22.669 2.462 31.527.966 0 0 .99-76.559.972-87.741v-4.584c-.667-14.95-5.643-27.437-7.363-42.14-1.409.398-2.628 1.07-3.514 1.64-.316.201-.477 1.513-.558 1.881-.54 2.48-.713 3.204-1.104 5.798-.38 2.537-1.099 5.022-1.318 7.575-.023.27-.04.553.052.806.11.305.357.54.599.759a85.786 85.786 0 0 0 5.337 4.452c-1.052 1.996-2.105 3.992-3.157 5.982-.11.201-.22.42-.208.65.012.224.179.391.3.581 2.312 3.716 7.96 8.409 10.272 12.125"
        fill="#fff"
      />

      <path
        d="M33.585 103.488c-2.933 20.926-6.666 49.036-11.182 98.014 8.795 1.829 22.669 2.462 31.527.966 0 0 .99-76.559.972-87.741v-4.584c-.667-14.95-5.643-27.437-7.363-42.14-1.409.398-2.628 1.07-3.514 1.64-.316.201-.477 1.513-.558 1.881-.54 2.48-.713 3.204-1.104 5.798-.38 2.537-1.099 5.022-1.318 7.575-.023.27-.04.553.052.806.11.305.357.54.599.759a85.786 85.786 0 0 0 5.337 4.452c-1.052 1.996-2.105 3.992-3.157 5.982-.11.201-.22.42-.208.65.012.224.179.391.3.581 2.312 3.716 7.96 8.409 10.272 12.125"
        stroke="#272C33"
        strokeWidth={1.99}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path d="M43.53 71.184c-2.231 1.081-5.613 4.175-6.735 4.975l6.736-4.975Z" fill="#fff" />

      <path
        d="M43.53 71.184c-2.231 1.081-5.613 4.175-6.735 4.975"
        stroke="#272C33"
        strokeWidth={1.99}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M69.023 71.185c2.232 1.081 5.028 3.716 6.143 4.521.248.178 8.364 53.982 14.984 125.802-8.794 1.829-19.752 2.49-28.616.995 0 0-3.664-73.488 3.48-134.487 1.41.396 2.629 1.07 3.515 1.639.316.201.477 1.513.558 1.88.54 2.48.713 3.205 1.104 5.799.38 2.537 1.099 5.021 1.317 7.575.023.27.04.552-.052.805-.109.305-.356.541-.598.76a85.786 85.786 0 0 1-5.338 4.452c1.053 1.996 2.106 3.992 3.158 5.982.11.201.219.42.207.65-.011.224-.132.425-.253.615-2.312 3.716-4.63 7.432-6.943 11.153"
        fill="#fff"
      />

      <path
        d="M77.49 91c2.934 20.926 8.145 61.524 12.66 110.502-8.794 1.829-22.668 2.462-31.526.966 0 0-.99-76.559-.972-87.741v-4.584c.667-14.95 5.642-27.437 7.362-42.14 1.41.398 2.629 1.07 3.515 1.64.316.201.477 1.513.558 1.881.54 2.48.713 3.204 1.104 5.798.38 2.537 1.099 5.022 1.317 7.575.023.27.04.553-.052.806-.109.305-.356.54-.598.759a85.786 85.786 0 0 1-5.338 4.452c1.053 1.996 2.106 3.992 3.158 5.982.11.201.219.42.207.65-.011.224-.178.391-.299.581-2.312 3.716-7.96 8.409-10.273 12.125"
        fill="#fff"
      />

      <path
        d="M77.49 91c2.934 20.926 8.145 61.524 12.66 110.502-8.794 1.829-22.668 2.462-31.526.966 0 0-.99-76.559-.972-87.741v-4.584c.667-14.95 5.642-27.437 7.362-42.14 1.41.398 2.629 1.07 3.515 1.64.316.201.477 1.513.558 1.881.54 2.48.713 3.204 1.104 5.798.38 2.537 1.099 5.022 1.317 7.575.023.27.04.553-.052.806-.109.305-.356.54-.598.759a85.786 85.786 0 0 1-5.338 4.452c1.053 1.996 2.106 3.992 3.158 5.982.11.201.219.42.207.65-.011.224-.178.391-.299.581-2.312 3.716-7.96 8.409-10.273 12.125"
        stroke="#272C33"
        strokeWidth={1.99}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path d="M69.023 71.184c2.232 1.081 5.027 3.715 6.143 4.52l-6.143-4.52Z" fill="#fff" />

      <path
        d="M69.023 71.184c2.232 1.081 5.027 3.715 6.143 4.52"
        stroke="#272C33"
        strokeWidth={1.99}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M64.876 78.25c-.46.47-1.593 1.754-1.887 3.744-.074.523-.247 1.783.311 3.106 1.133 2.692 4.285 3.336 4.625 3.4 0 0-1.294-2.106-1.168-3.94.127-1.836.77-3.348 1.87-4.775 1.294-1.674 1.972-2.45 3.618-3.739 1.616-1.265 2.772-2.859 3.94-4.59 1.415-2.1 1.282-5.263.696-7.765-.587-2.502-1.674-5.614-6.805-9.52-1.254-1.173-1.996-.442-1.996-.442s-1.173.88-.034 2.162c.017.018-.006-.034-.024-.011-.011.023.018.034 0 .011 0 0 .788 2.037.576 3.354-.213 1.317-1.22 4.308-1.858 5.205-.639.898-2.629 3.578-2.962 3.929-.334.35-2.52 2.226-2.853 3.261-.328 1.036-1.116 1.944-.668 4.004.443 2.059 1.766 3.583 1.766 3.583s-.029 1.41.621 2.853c.553 1.225.156.754.627 1.225.08.08.213.184.346.357M70.847 5.635C64.364.297 55-.543 47.752 3.558l.023.023C25.66 10.167 26.574 38.703 40 51.271c6.436 6.028 15.363 8.542 25.182 3.83 0 0 11.694-7.575 14.54-14.195.823-1.916 2.02-4.907 2.37-8.128.593-5.406-.103-10.997-2.214-15.961-2.117-4.964-5.683-9.267-10.18-11.907"
        fill="#2BA168"
      />

      <path
        d="M62.017 78.786c-1.329-1.392-1.979-3.537-1.708-5.464.23-1.634 1.541-3.21 2.68-4.377 2.083-2.134 3.877-3.93 4.947-6.621 1.07-2.698 1.444-4.757.31-6.747 0 0-1.046-1.122-.166-1.95 1.277-1.202 2.249-.04 2.249-.04 5.274 3.842 6.586 7.195 7.19 9.692.604 2.496.742 5.654-.713 7.748-1.203 1.725-2.399 3.313-4.061 4.578-1.691 1.289-2.393 2.06-3.728 3.728-1.133 1.42-1.794 2.933-1.926 4.762-.133 1.83 1.202 3.929 1.202 3.929-1.743-.892-3.222-1.323-4.406-2.928-.88-1.19-2.56-4.452-1.876-6.316M70.334 5.638C64.64 1.818 58.911.179 52.866 1.388a20.176 20.176 0 0 0-5.937 2.179l.023.023c-6.867 2.019-10.25 6.097-13.045 11.142-6.321 11.429-4.274 27.828 5.165 36.548 6.529 6.028 15.57 8.541 25.522 3.83 0 0 11.855-7.575 14.737-14.195.834-1.916 2.041-4.907 2.398-8.128.598-5.407-.103-10.998-2.249-15.962-2.145-4.964-6.166-9.18-9.151-11.181l.005-.006Z"
        stroke="#272C33"
        strokeWidth={1.99}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <mask
        id="CheckInQr_svg__d"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={31}
        y={10}
        width={27}
        height={54}
      >
        <path d="M58 10.305H31.267v52.717H58V10.305Z" fill="#fff" />
      </mask>

      <g mask="url(#CheckInQr_svg__d)">
        <path
          d="M59.402 63.018c-1.799-.057-4.512-.356-5.976-.707-2.707-.656-5.89-1.726-9.793-5.074-2.201-1.886-3.689-4.032-5.091-6.988-3.031-.397-5.775-2.428-6.83-5.12-.415-1.064-.585-2.237-.31-3.341.273-1.105 1.011-2.134 2.084-2.652 1.074-.518 2.47-.46 3.184-.092-1.305-5.907-.629-12.194 1.914-17.733 1.116-2.433 2.604-4.752 4.69-6.529 2.872-2.456 6.707-3.727 10.549-4.205 3.841-.477 7.744-.224 11.61.035"
          fill="#fff"
        />
      </g>

      <mask
        id="CheckInQr_svg__e"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={56}
        y={10}
        width={26}
        height={54}
      >
        <path d="M81.7 10.305H56.485v52.717H81.7V10.305Z" fill="#fff" />
      </mask>

      <g mask="url(#CheckInQr_svg__e)">
        <path
          d="M55.16 63.018c1.698-.057 4.257-.356 5.638-.707 2.554-.656 5.556-1.726 9.237-5.074 2.077-1.886 3.48-4.032 4.803-6.988 2.86-.397 5.448-2.428 6.443-5.12.39-1.064.552-2.237.293-3.341-.253-1.105-.955-2.134-1.967-2.652-1.013-.518-2.33-.46-3.003-.092a29.716 29.716 0 0 0-1.806-17.733c-1.052-2.433-2.456-4.752-4.423-6.529-2.71-2.456-6.327-3.727-9.951-4.205-3.624-.477-7.305-.224-10.952.035"
          fill="#fff"
        />
      </g>

      <path
        d="M51.17 62.092c-1.795-.604-4.775-1.76-8.105-4.786-2.146-1.95-3.595-4.164-4.964-7.224-2.957-.409-5.631-2.508-6.661-5.286-.408-1.1-.57-2.313-.305-3.457.265-1.145.984-2.203 2.03-2.744 1.047-.535 2.41-.477 3.1-.092-.39-3.422-.954-11.66 2.624-19.074 1.938-4.015 4.204-5.953 4.728-6.384 2.49-2.065 4.924-2.934 6.782-3.383 6.08-1.478 12.39-.339 13.902.645"
        stroke="#272C33"
        strokeWidth={1.99}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M61.408 61.981c1.794-.603 4.774-1.76 8.104-4.785 2.146-1.95 3.595-4.164 4.964-7.225 2.957-.408 5.631-2.507 6.661-5.286.408-1.098.57-2.312.305-3.457-.265-1.144-.984-2.203-2.03-2.743-1.047-.535-2.41-.478-3.1-.092.39-3.423.954-11.66-2.624-19.074-1.938-4.015-4.204-5.953-4.728-6.385-2.49-2.065-4.952-2.83-6.781-3.382-5.505-1.656-10.28.058-13.639.72"
        stroke="#272C33"
        strokeWidth={1.99}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <mask
        id="CheckInQr_svg__f"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={42}
        y={28}
        width={7}
        height={4}
      >
        <path d="M48.943 28.059H42.19v3.554h6.753V28.06Z" fill="#fff" />
      </mask>

      <g mask="url(#CheckInQr_svg__f)">
        <path
          d="M48.345 28.652a8.495 8.495 0 0 0-5.562 2.364"
          stroke="#272C33"
          strokeWidth={1.191}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <mask
        id="CheckInQr_svg__g"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={63}
        y={28}
        width={8}
        height={4}
      >
        <path d="M70.56 28.059h-6.753v3.554h6.752V28.06Z" fill="#fff" />
      </mask>

      <g mask="url(#CheckInQr_svg__g)">
        <path
          d="M64.404 28.652c2.06.07 4.084.932 5.563 2.364"
          stroke="#272C33"
          strokeWidth={1.191}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <path
        d="M56.45 46.063a5.332 5.332 0 0 0 .011 2.133"
        stroke="#272C33"
        strokeWidth={1.593}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <mask
        id="CheckInQr_svg__h"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={44}
        y={38}
        width={5}
        height={6}
      >
        <path d="M44.584 38.246h4.354v5.47h-4.355v-5.47Z" fill="#fff" />
      </mask>

      <g mask="url(#CheckInQr_svg__h)">
        <path
          d="M46.89 43.715c1.13 0 2.048-1.164 2.048-2.6 0-1.435-.917-2.6-2.048-2.6-1.13 0-2.048 1.165-2.048 2.6 0 1.436.917 2.6 2.048 2.6Z"
          fill="#272C33"
        />

        <path
          d="M45.176 38.836c.224.247.454.495.678.742"
          stroke="#272C33"
          strokeWidth={1.191}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <mask
        id="CheckInQr_svg__i"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={63}
        y={38}
        width={5}
        height={6}
      >
        <path d="M67.465 38.246h-4.36v5.47h4.36v-5.47Z" fill="#fff" />
      </mask>

      <g mask="url(#CheckInQr_svg__i)">
        <path
          d="M65.152 43.715c1.131 0 2.048-1.164 2.048-2.6 0-1.435-.917-2.6-2.048-2.6-1.13 0-2.047 1.165-2.047 2.6 0 1.436.916 2.6 2.047 2.6Z"
          fill="#272C33"
        />

        <path
          d="M66.866 38.836c-.224.247-.454.495-.678.742"
          stroke="#272C33"
          strokeWidth={1.191}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <path
        d="M71.1 33.548c-2.25-.34-7.8-1.478-12.936-6.022-4.608-4.073-6.477-8.766-7.196-10.94-.34 2.363-1.289 6.672-4.354 11.032-4.297 6.114-10.095 8.547-12.355 9.364-1.14-.627-.277-.702-.725-1.921-.409-1.105-.817-2.991-.955-4.159-.173-1.461.242-4.303.506-5.746.184-.995.477-2.042.897-3.32.91-2.737 1.847-5.573 3.86-8.316 2.629-3.59 5.861-5.338 7.5-6.201 5.01-2.64 9.549-2.79 10.906-2.796 1.565 0 2.767.156 3.262.23 5.625.835 9.364 3.705 10.888 4.895 3.1 2.44 4.855 5.005 5.384 5.804 5.597 8.525 3.612 17.469 3.077 19.131-.184.581-.834 2.612-1.156 2.554-.046-.011-.08-.063-.092-.103"
        fill="#2BA168"
      />

      <path d="M60.108 19.293c3.267 7.495 9.87 14.08 17.216 17.693L60.108 19.293Z" fill="#2BA168" />

      <path
        d="M35.374 36.58c9.227-4.83 14.173-10.307 15.433-20.459.31.897.777 2.111 1.467 3.486.46.92 2.324 4.504 5.407 7.472 4.923 4.728 11.072 6.068 13.425 6.47"
        stroke="#272C33"
        strokeWidth={1.99}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M60.108 19.293c3.267 7.495 9.813 14.046 17.158 17.664"
        stroke="#272C33"
        strokeWidth={1.99}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M105.266 75.73H75.011a.978.978 0 0 0-.978.978v42.099c0 .54.438.978.978.978h30.255a.978.978 0 0 0 .978-.978V76.708a.977.977 0 0 0-.978-.977Z"
        fill="#2BA168"
        stroke="#272C33"
        strokeWidth={1.726}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path fill="#fff" d="M78.5 81.094h23.163v23.163H78.5z" />

      <path
        d="M82.843 91.95c-.398 0-.739-.141-1.022-.425a1.394 1.394 0 0 1-.425-1.022v-5.067c0-.398.141-.739.425-1.023a1.394 1.394 0 0 1 1.022-.425h5.067c.398 0 .739.142 1.022.425.284.284.426.625.426 1.023v5.067c0 .398-.142.739-.426 1.022a1.394 1.394 0 0 1-1.022.425h-5.067Zm0-1.447h5.067v-5.067h-5.067v5.067Zm0 10.857c-.398 0-.739-.142-1.022-.425a1.394 1.394 0 0 1-.425-1.022v-5.067c0-.398.141-.74.425-1.023a1.394 1.394 0 0 1 1.022-.425h5.067c.398 0 .739.142 1.022.425.284.284.426.625.426 1.023v5.067c0 .398-.142.738-.426 1.022a1.396 1.396 0 0 1-1.022.425h-5.067Zm0-1.447h5.067v-5.067h-5.067v5.067Zm9.41-7.963c-.398 0-.739-.141-1.022-.425a1.394 1.394 0 0 1-.426-1.022v-5.067c0-.398.142-.739.426-1.023a1.394 1.394 0 0 1 1.022-.425h5.067c.398 0 .739.142 1.022.425.284.284.425.625.425 1.023v5.067c0 .398-.141.739-.425 1.022a1.394 1.394 0 0 1-1.022.425h-5.067Zm0-1.447h5.067v-5.067h-5.067v5.067Zm4.898 10.857a.348.348 0 0 1-.253-.108.349.349 0 0 1-.109-.254v-1.254c0-.097.036-.181.109-.254a.347.347 0 0 1 .253-.108h1.255c.096 0 .18.036.253.108a.347.347 0 0 1 .108.254v1.254a.349.349 0 0 1-.108.254.348.348 0 0 1-.254.108h-1.254Zm-5.984-5.96a.347.347 0 0 1-.253-.108.347.347 0 0 1-.109-.253V93.76c0-.097.036-.181.109-.253a.347.347 0 0 1 .253-.109h1.255c.096 0 .18.036.253.109a.347.347 0 0 1 .109.253v1.279c0 .096-.036.18-.109.253a.347.347 0 0 1-.253.109h-1.255Zm1.979 1.98a.347.347 0 0 1-.254-.11.347.347 0 0 1-.108-.253v-1.254c0-.097.036-.181.108-.254a.347.347 0 0 1 .254-.108h1.278c.097 0 .181.036.254.108a.347.347 0 0 1 .108.254v1.254a.347.347 0 0 1-.108.254.347.347 0 0 1-.254.108h-1.278Zm-1.979 2.002a.347.347 0 0 1-.253-.109.347.347 0 0 1-.109-.253V97.74c0-.096.036-.18.109-.253a.347.347 0 0 1 .253-.109h1.255c.096 0 .18.036.253.109a.347.347 0 0 1 .109.253v1.279a.347.347 0 0 1-.109.253.347.347 0 0 1-.253.109h-1.255Zm1.979 1.978a.348.348 0 0 1-.254-.108.349.349 0 0 1-.108-.254v-1.254c0-.097.036-.181.108-.254a.347.347 0 0 1 .254-.108h1.278c.097 0 .181.036.254.108a.347.347 0 0 1 .108.254v1.254a.349.349 0 0 1-.108.254.348.348 0 0 1-.254.108h-1.278Zm2.002-1.978a.347.347 0 0 1-.253-.109.347.347 0 0 1-.109-.253V97.74c0-.096.037-.18.109-.253a.347.347 0 0 1 .253-.109h1.28c.096 0 .18.036.252.109a.347.347 0 0 1 .109.253v1.279a.347.347 0 0 1-.109.253.347.347 0 0 1-.253.109h-1.279Zm0-3.981a.347.347 0 0 1-.253-.109.347.347 0 0 1-.109-.253V93.76c0-.097.037-.181.109-.253a.347.347 0 0 1 .253-.109h1.28c.096 0 .18.036.252.109a.347.347 0 0 1 .109.253v1.279c0 .096-.036.18-.109.253a.347.347 0 0 1-.253.109h-1.279Zm2.003 1.978a.347.347 0 0 1-.253-.108.347.347 0 0 1-.109-.254v-1.254c0-.097.036-.181.109-.254a.347.347 0 0 1 .253-.108h1.255c.096 0 .18.036.253.108a.347.347 0 0 1 .108.254v1.254a.347.347 0 0 1-.108.254.347.347 0 0 1-.254.108h-1.254Z"
        fill="#272C33"
      />

      <path
        d="m105.75 63.375-1.634 5.85M113.762 67.809l-4.469 4.118M118.295 74.387l-5.649 2.237"
        stroke="#272C33"
        strokeWidth={2.301}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />

      <path
        d="M66.855 99.95c-1.743 1.352-4.982 3.382-7.633 1.242l-4.752 2.341-4.09-7.96c4.712-.95 6.265-2.646 9.704-5.419a80.885 80.885 0 0 1 5.545-4.141c3.906-2.686 6.575-3.336 6.926-3.566 1.11-.472 2.358-.788 2.922.465.713 1.577-1.168 2.428-1.709 2.687-2.83 1.357-5.102 2.33-5.188 2.755 0 .046-.034.138.035.155 1.3.265 5.556 2.819 4.21 5.378-.765 1.456-.598.811-1.07 1.433 0 0 .225.914.276 1.553-.16 2.024-3.951 4.164-5.17 3.088"
        fill="#fff"
      />

      <path
        d="M66.855 99.95c-1.743 1.352-4.982 3.382-7.633 1.242l-4.752 2.341-4.09-7.96c4.712-.95 6.265-2.646 9.704-5.419a80.885 80.885 0 0 1 5.545-4.141c3.906-2.686 6.575-3.336 6.926-3.566 1.11-.472 2.358-.788 2.922.465.713 1.577-1.168 2.428-1.709 2.687-2.83 1.357-5.102 2.33-5.188 2.755 0 .046-.034.138.035.155 1.3.265 5.556 2.819 4.21 5.378-.765 1.456-.598.811-1.07 1.433 0 0 .225.914.276 1.553-.16 2.024-3.951 4.164-5.17 3.088"
        stroke="#272C33"
        strokeWidth={2.013}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M67.7 92.094c2.836 1.386 3.998 3.094 4.107 3.146M66.998 95.637c1.68.931 3.492 1.932 3.302 3.353"
        stroke="#272C33"
        strokeWidth={2.013}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M23.278 107.344c-.621 1.3 1.42 6.183 1.501 7.593.328 5.734 7.743 7.063 12.66 5.361 3.55-1.231 16.59-11.464 20.938-16.422-4.257-5.74-8.076-8.283-10.665-8.755-3.25 2.404-15.559 8.49-19.085 11.728l-5.343.489-.006.006Z"
        fill="#fff"
      />

      <path
        d="M22.709 106.164c-.058.759-.3 5.574 2.634 9.571.489.668 2.899 3.785 6.902 4.481 2.94.512 5.631-.483 10.4-3.497 3.911-2.473 9.306-6.362 15.093-12.252-.84-2.059-1.323-2.91-3.273-5.602-1.593-2.197-3.79-3.762-5.55-4.521-4.63 2.594-12.246 7.443-16.877 10.037"
        stroke="#272C33"
        strokeWidth={1.99}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M127.021 119.777H1.363v4.677H127.02v-4.677ZM122.453 124.457H5.93v85.676h116.523v-85.676Z"
        fill="#fff"
        stroke="#272C33"
        strokeWidth={1.726}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M52.866 52.941s1.22.754 3.653.754c2.726 0 3.589-.754 3.589-.754"
        stroke="#272C33"
        strokeWidth={1.593}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>

    <defs>
      <clipPath id="CheckInQr_svg__a">
        <path fill="#fff" d="M0 0h128v136H0z" />
      </clipPath>
    </defs>
  </svg>
);

const Memo = memo(SvgCheckInQr);

export default Memo;
